// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2L0g8","tabsBox":"styles_tabsBox__3Czht","createButton":"styles_createButton__18CSL"};